import { render, staticRenderFns } from "./FleetsSvg.vue?vue&type=template&id=164f7989"
import script from "./FleetsSvg.vue?vue&type=script&lang=js"
export * from "./FleetsSvg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports